import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../images/MainLogo_Big.png';
import Popup from "../Popup";
import styled from 'styled-components';
import fileManager from '../../images/FileManager.png';
import BrandLogo from '../../images/BrandLogo.png';
import MarketLogo from '../../images/StoreLogo.png';
import AssetMarketLogo from '../../images/AssetStoreLogo.png';
import NodeLogo from '../../images/NodeLogo.png';
import AdminLogo from '../../images/AdminLogo.png'; //공장MES와 어울림
import RemoteDesktopLogo from '../../images/RemoteLogo.png';
import EstimateLogo from '../../images/EstimateLogo.png';
import bigData from '../../images/bigData.jpg';
import vrarLogo from '../../images/vrarLogo.png';
import logic from '../../images/logic.png';
import AILogo from '../../images/AILogo.png';
import web3 from '../../images/web3.png';
import MyLogo from '../../images/MyLogo.png';
import Skyscribe from '../../images/SkyscribeLogo.png';
import ganttChart from '../../images/gantchart.gif';
import AntsTalk from '../../images/AntsTalk.gif';
import Telant from '../../images/Telant.webp';
import './style.css';
import './Tab.css';
import Divider from './Divider.jsx';
import { serviceUrl, externalServiceUrl } from '../../utils/siblingSite';

// 우측 영역 (사용자 메뉴 + 앱버튼)
const RightSection = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 10px;
`;

const LoginButton = styled.button`
    background: transparent;
    color: #8BD2F4;
    border: 1px solid rgba(139, 210, 244, 0.45);
    border-radius: 8px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    letter-spacing: 0.2px;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

    &:hover {
        background: rgba(139, 210, 244, 0.12);
        color: #fff;
        border-color: #8BD2F4;
    }
    &:focus-visible {
        outline: 2px solid #8BD2F4;
        outline-offset: 2px;
    }
`;

export default function Navigator(){
    const [isToggled, setIsToggled] = useState(false);
    const [userToggled] = useState(false);
    // 팝업 열리고 닫는거
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    // 로그인 사용자 정보
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    // 세션 확인
    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await fetch('/api/check-session', {
                    method: 'GET',
                    credentials: 'include',
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.user) {
                        setUser(data.user);
                    }
                }
            } catch (error) {
                console.error('세션 확인 오류:', error);
            }
        };
        checkSession();
    }, []);

    const handleLogoClick = ()=>{
        setIsPopupOpen(true);
    }
    const closePopup = ()=>{
        setIsPopupOpen(false);
    }

    const handleLogout = async () => {
        try {
            await fetch('/api/logout', { method: 'GET', credentials: 'include' });
        } catch (e) { /* ignore */ }
        setUser(null);
        window.location.href = '/';
    };

      return(
        <header className="MainHeader" isToggled={isToggled} userToggled={userToggled}>
            <div className="headerContainer">
                <div className="logo">
                    <Link to={'/'} className="home" onClick={handleLogoClick}>
                        <div className="logo">
                            <img className="logoImg" src={Logo} />
                        </div>
                    </Link>
                </div>
                <Popup isOpen={isPopupOpen} handleClose={closePopup}/>
                <ul className="header__menulist">
                    <Link to={'/Company'} className="company" style={{ color: '#fff', textDecoration: 'none' }}><li>Company</li></Link>
                    <Link to={'/Service'} className="service" style={{ color: '#fff', textDecoration: 'none' }}><li>Service</li></Link>
                    <Link to={'/Business'} className="business" style={{ color: '#fff', textDecoration: 'none' }}><li>Business</li></Link>
                    <Link to={'/Contact'} className="contact" style={{ color: '#fff', textDecoration: 'none' }}><li>Contact</li></Link>
                    <Link to={'/Download'} className="download" style={{ color: '#fff', textDecoration: 'none' }}><li>Download</li></Link>
                </ul>
                <RightSection>
                    {user
                        ? <UserMenu user={user} onNavigate={navigate} onLogout={handleLogout}/>
                        : <LoginButton type="button" onClick={() => navigate('/Login')}>Login</LoginButton>
                    }
                    <SlideTab/>
                </RightSection>
            </div>
        </header>
      );
}

function getInitial(user) {
    const source = user.user_name || user.nickname || user.user_account || '?';
    return source.trim().charAt(0).toUpperCase();
}

function UserMenu({ user, onNavigate, onLogout }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    const displayName = user.user_name || user.nickname || user.user_account;

    return (
        <div className="user-menu" ref={ref}>
            <button
                type="button"
                className="user-menu-trigger"
                onClick={() => setOpen(o => !o)}
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label="사용자 메뉴"
            >
                <span className="user-menu-avatar">
                    {user.avatar_url
                        ? <img src={user.avatar_url} alt="" />
                        : <span className="user-menu-initial">{getInitial(user)}</span>}
                </span>
                <svg className={`user-menu-chevron ${open ? 'open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <polyline points="6 9 12 15 18 9"/>
                </svg>
            </button>
            {open && (
                <div className="user-menu-dropdown" role="menu">
                    <div className="user-menu-header">
                        <span className="user-menu-avatar large">
                            {user.avatar_url
                                ? <img src={user.avatar_url} alt="" />
                                : <span className="user-menu-initial">{getInitial(user)}</span>}
                        </span>
                        <div className="user-menu-id">
                            <p className="user-menu-name">{displayName}</p>
                            {user.user_email && <p className="user-menu-email">{user.user_email}</p>}
                        </div>
                    </div>
                    <div className="user-menu-divider"/>
                    {user.user_account === 'admin@antsnest.co.kr' && (
                        <button type="button" className="user-menu-item admin" role="menuitem" onClick={() => { setOpen(false); onNavigate('/Admin'); }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z"/>
                            </svg>
                            <span>관리 페이지</span>
                        </button>
                    )}
                    <button type="button" className="user-menu-item" role="menuitem" onClick={() => { setOpen(false); onNavigate('/Download'); }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="7 10 12 15 17 10"/>
                            <line x1="12" y1="15" x2="12" y2="3"/>
                        </svg>
                        <span>내 자료실</span>
                    </button>
                    <button type="button" className="user-menu-item danger" role="menuitem" onClick={() => { setOpen(false); onLogout(); }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                            <polyline points="16 17 21 12 16 7"/>
                            <line x1="21" y1="12" x2="9" y2="12"/>
                        </svg>
                        <span>로그아웃</span>
                    </button>
                </div>
            )}
        </div>
    );
}



const APPS = [
  { name: '노드마스터', href: `/api/sso/check?redirect=${encodeURIComponent(externalServiceUrl('nodemaster.co.kr'))}`, bg: 'linear-gradient(135deg, #4F46E5, #7C3AED)', sso: true,
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="2.5"/><circle cx="5" cy="19" r="2.5"/><circle cx="19" cy="19" r="2.5"/><line x1="12" y1="7.5" x2="5" y2="16.5"/><line x1="12" y1="7.5" x2="19" y2="16.5"/><line x1="7.5" y1="19" x2="16.5" y2="19"/></svg> },
  { name: '기준정보관리', href: serviceUrl('app'), bg: 'linear-gradient(135deg, #0284C7, #06B6D4)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6"/><path d="M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"/></svg> },
  { name: '클라우드', href: externalServiceUrl('skynet.re.kr'), bg: 'linear-gradient(135deg, #0EA5E9, #38BDF8)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg> },
  { name: '파일 저장소', href: externalServiceUrl('file.skynet.re.kr'), bg: 'linear-gradient(135deg, #D97706, #F59E0B)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg> },
  { name: '앤츠톡', href: serviceUrl('talk'), bg: 'linear-gradient(135deg, #DB2777, #EC4899)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> },
  { name: '앤츠 피플', href: serviceUrl('story'), bg: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> },
  { name: '웹플레이어', href: externalServiceUrl('skyscribe.co.kr'), bg: 'linear-gradient(135deg, #059669, #34D399)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8" fill="#fff" stroke="#fff"/></svg> },
  { name: '앤츠미팅', href: serviceUrl('cast'), bg: 'linear-gradient(135deg, #DC2626, #F87171)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7" fill="#fff"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg> },
  { name: '서비스마켓', href: serviceUrl('store'), bg: 'linear-gradient(135deg, #EA580C, #FB923C)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.3)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { name: '미니그로우', href: externalServiceUrl('minigrow.kr'), bg: 'linear-gradient(135deg, #16A34A, #4ADE80)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 20h10"/><path d="M10 20c5.5-2.5.8-6.4 3-10"/><path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2-.4-3.5-1.4-4.3-2.6-1.1-1.5-1.5-3.5-1.3-5.5 2.4-.4 4.5.4 5.6 1.9.7.9 1.1 2 1.2 3.2"/><path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1.1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2"/></svg> },
  { name: 'AR대탈출', href: serviceUrl('play'), bg: 'linear-gradient(135deg, #7E22CE, #A855F7)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.2)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 4h3a2 2 0 0 1 2 2v14"/><path d="M2 20h20"/><path d="M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"/><path d="M10 12v.01"/></svg> },
  { name: '견적서', href: serviceUrl('estimate'), bg: 'linear-gradient(135deg, #475569, #64748B)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(255,255,255,0.2)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
  { name: '메타월드', href: serviceUrl('meta'), bg: 'linear-gradient(135deg, #B45309, #F59E0B)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z"/><path d="M6 15v-2"/><path d="M18 15v-2"/><path d="M12 12V6"/><circle cx="12" cy="4" r="2" fill="#fff"/></svg> },
  { name: '간트 차트', href: serviceUrl('wbs'), bg: 'linear-gradient(135deg, #1D4ED8, #3B82F6)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="3" x2="9" y2="21"/></svg> },
  { name: 'AI Agent', href: serviceUrl('malbok'), bg: 'linear-gradient(135deg, #0F766E, #14B8A6)',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><circle cx="9" cy="13" r="1" fill="#fff"/><circle cx="15" cy="13" r="1" fill="#fff"/><path d="M9 17h6"/></svg> },
];

function AppsTriggerButton({ onClick, isOpen }) {
    return (
        <button
            type="button"
            className="apps-trigger-btn"
            onClick={onClick}
            aria-label="앱 메뉴 열기"
            aria-expanded={isOpen}
            aria-controls="apps-drawer"
        >
            <svg width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <circle cx="6" cy="6" r="2" fill="#fff"/>
                <circle cx="12" cy="6" r="2" fill="#fff"/>
                <circle cx="18" cy="6" r="2" fill="#fff"/>
                <circle cx="6" cy="12" r="2" fill="#fff"/>
                <circle cx="12" cy="12" r="2" fill="#fff"/>
                <circle cx="18" cy="12" r="2" fill="#fff"/>
                <circle cx="6" cy="18" r="2" fill="#fff"/>
                <circle cx="12" cy="18" r="2" fill="#fff"/>
                <circle cx="18" cy="18" r="2" fill="#fff"/>
            </svg>
        </button>
    );
}

function SlideTab() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTab = () => setIsOpen(prev => !prev);
  const closeTab = () => setIsOpen(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') closeTab(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  return (
    <>
      <AppsTriggerButton onClick={toggleTab} isOpen={isOpen}/>
      <div
        className={`tab-overlay ${isOpen ? 'open' : ''}`}
        onClick={closeTab}
        aria-hidden="true"
      />
      <aside
        id="apps-drawer"
        className={`tab-container ${isOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="앱 메뉴"
      >
        <header className="apps-header">
          <div className="apps-header-text">
            <h2>Apps</h2>
            <p>AntsNest 전체 서비스 ({APPS.length})</p>
          </div>
          <button
            type="button"
            className="apps-close-btn"
            onClick={closeTab}
            aria-label="닫기"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="6" y1="6" x2="18" y2="18"/>
              <line x1="6" y1="18" x2="18" y2="6"/>
            </svg>
          </button>
        </header>
        <div className="apps-grid">
          {APPS.map((app, i) => (
            <a
              key={app.name}
              href={app.href}
              className="app-cell"
              style={{ animationDelay: `${i * 30}ms` }}
              {...(app.sso ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
            >
              <div className="app-icon-box" style={{ background: app.bg }}>
                {app.icon}
              </div>
              <span className="app-label">{app.name}</span>
            </a>
          ))}
        </div>
      </aside>
    </>
  );
}